<div class="container landing-container profile-page-wrapper">
    <div class="profile-wrap-head">
        <div class="profile-wrap-inner">
            <img src="./assets/images/profile-avatar.png" alt="Avatar" class="user-profile">
            <div>
                <h3 class="user-name">Nick Nolte</h3>
                <ul class="info-showcase">
                    <li>
                        <img src="./assets/images/ic-star.svg" alt="Star">
                        7 reviews
                    </li>
                    <li>
                        <img src="./assets/images/ic-photo.svg" alt="Star">
                        9 photos
                    </li>
                </ul>
                <button class="btn btn-outline-primary" title="Edit Details" routerLink="/ui-edit-details">Edit
                    Details</button>
            </div>
        </div>

        <div class="advertisement-wrapper">
            <div class="advertisement-inner">
                <img src="./assets/images/advertisement-1.png" alt="Advertisement">
            </div>
        </div>
    </div>

    <div class="data-showcase-grid">
        <h4 class="grid-title">Personal Details</h4>
        <div class="row">
            <div class="col-sm-6 col-md-4 col-lg-3">
                <label class="data-label">First Name</label>
                <h5 class="data-text">john</h5>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <label class="data-label">First Name</label>
                <h5 class="data-text">moniker</h5>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <label class="data-label">Email ID</label>
                <h5 class="data-text">johnmoniker@gmail.com</h5>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <label class="data-label">Phone Number</label>
                <h5 class="data-text">98589 45123</h5>
            </div>
        </div>
    </div>
    <div class="data-showcase-grid">
        <h4 class="grid-title">Address Details</h4>
        <div class="row">
            <div class="col-sm-6 col-md-4 col-lg-3">
                <label class="data-label">Address</label>
                <h5 class="data-text">john</h5>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <label class="data-label">City</label>
                <h5 class="data-text">moniker</h5>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <label class="data-label">Zip</label>
                <h5 class="data-text">johnmoniker@gmail.com</h5>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3">
                <label class="data-label">Location</label>
                <h5 class="data-text">Stepherd Park 451256</h5>
            </div>
        </div>
    </div>
    <div class="data-showcase-grid">
        <h4 class="grid-title">Social Media</h4>
        <div class="row">
            <div class="col-sm-6 col-md-4">
                <label class="data-label">Instagram</label>
                <h5 class="data-text">
                    <span class="data-span">
                        johnmoniker12
                    </span>
                </h5>
            </div>
            <div class="col-sm-6 col-md-4">
                <label class="data-label">TikTok</label>
                <h5 class="data-text">
                    <span class="data-span">tiktok_johnmoniker12</span>
                </h5>
            </div>
            <div class="col-sm-6 col-md-4">
                <label class="data-label">Facebook</label>
                <h5 class="data-text">
                    <span class="data-span">johnmoniker</span>
                </h5>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-8">
            <div class="public-review-wrap">
                <div class="review-head">
                    <h4 class="grid-title">
                        Reviews <span class="review-count">(7 reviews)</span>
                    </h4>

                    <ul class="tabs-ul">
                        <li><a href="#" [class.active]="activeTab === 'withRating'"
                                (click)="showWithRating(($event))">By
                                Rating</a></li>
                        <li><a href="#" [class.active]="activeTab === 'new'" (click)="showNew(($event))">New</a></li>
                    </ul>
                </div>

                <div class="review-wrap-body">
                    <div class="tab-slide" *ngIf="activeTab === 'withRating'">
                        <div class="review-card">
                            <div class="review-card-head">
                                <img src="./assets/images/review-avatar-1.png" alt="Image" class="review-profile">
                                <div class="review-info-block">
                                    <h4 class="food-name">Diamond Slice Pizza</h4>
                                    <h6 class="place-type">Restaurant</h6>
                                </div>
                                <div class="rating-block">
                                    <div class="ratig-inner">
                                        <h5 class="ratings">4.3</h5>
                                        <span class="rating-icon">
                                            <img src="./assets/images/ic-primary-rating.svg" alt="Rating">
                                        </span>
                                    </div>
                                    <p class="rated-time">2 days ago</p>
                                </div>
                            </div>
                            <div class="review-card-body">
                                <h4 class="review-text-data">
                                    Love this place! Fresh and delicious food and they even make their own bread. My go
                                    to
                                    spot for breakfast and lately a
                                    quick stop for happy hour.
                                </h4>
                                <ul class="info-showcase">
                                    <li>
                                        <img src="./assets/images/ic-photo.svg" alt="Star">
                                        3 photos
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="review-card">
                            <div class="review-card-head">
                                <img src="./assets/images/review-avatar-2.png" alt="Image" class="review-profile">
                                <div class="review-info-block">
                                    <h4 class="food-name">Homeroom</h4>
                                    <h6 class="place-type">Restaurant</h6>
                                </div>
                                <div class="rating-block">
                                    <div class="ratig-inner">
                                        <h5 class="ratings">4.3</h5>
                                        <span class="rating-icon">
                                            <img src="./assets/images/ic-primary-rating.svg" alt="Rating">
                                        </span>
                                    </div>
                                    <p class="rated-time">2 days ago</p>
                                </div>
                            </div>
                            <div class="review-card-body">
                                <h4 class="review-text-data">
                                    Super! We booked the sunset ride with cowboy bbq. What a blast! Beautiful scenery,
                                    well
                                    kept horses and yummy bbq.
                                    Perfect! I can't wait to try the winery tour next time!
                                </h4>
                                <ul class="info-showcase">
                                    <li>
                                        <img src="./assets/images/ic-photo.svg" alt="Star">
                                        5 photos
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="review-card">
                            <div class="review-card-head">
                                <img src="./assets/images/review-avatar-3.png" alt="Image" class="review-profile">
                                <div class="review-info-block">
                                    <h4 class="food-name">Vietnam Cafe</h4>
                                    <h6 class="place-type">Cafe</h6>
                                </div>
                                <div class="rating-block">
                                    <div class="ratig-inner">
                                        <h5 class="ratings">4.3</h5>
                                        <span class="rating-icon">
                                            <img src="./assets/images/ic-primary-rating.svg" alt="Rating">
                                        </span>
                                    </div>
                                    <p class="rated-time">2 days ago</p>
                                </div>
                            </div>
                            <div class="review-card-body">
                                <h4 class="review-text-data">
                                    Wow and wow! Everything was perfect for our annual party. All of our friends and
                                    family
                                    loved the food. The food was
                                    excellent, the display was beautiful and Elliot and his wife were prompt, courteous
                                    and
                                    professional. My only complaint
                                    is that I didn't take a picture. Thanks again for making our party a huge success!
                                </h4>
                                <ul class="info-showcase">
                                    <li>
                                        <img src="./assets/images/ic-photo.svg" alt="Star">
                                        2 photos
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="review-card">
                            <div class="review-card-head">
                                <img src="./assets/images/review-avatar-3.png" alt="Image" class="review-profile">
                                <div class="review-info-block">
                                    <h4 class="food-name">Homeroom</h4>
                                    <h6 class="place-type">Restaurant</h6>
                                </div>
                                <div class="rating-block">
                                    <div class="ratig-inner">
                                        <h5 class="ratings">4.3</h5>
                                        <span class="rating-icon">
                                            <img src="./assets/images/ic-primary-rating.svg" alt="Rating">
                                        </span>
                                    </div>
                                    <p class="rated-time">2 days ago</p>
                                </div>
                            </div>
                            <div class="review-card-body">
                                <h4 class="review-text-data">
                                    Super! We booked the sunset ride with cowboy bbq. What a blast! Beautiful scenery,
                                    well
                                    kept horses and yummy bbq.
                                    Perfect! I can't wait to try the winery tour next time!
                                </h4>
                                <ul class="info-showcase">
                                    <li>
                                        <img src="./assets/images/ic-photo.svg" alt="Star">
                                        3 photos
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="tab-slide" *ngIf="activeTab === 'new'">
                        <div class="review-card">
                            <div class="review-card-head">
                                <img src="./assets/images/review-avatar-3.png" alt="Image" class="review-profile">
                                <div class="review-info-block">
                                    <h4 class="food-name">Homeroom</h4>
                                    <h6 class="place-type">Restaurant</h6>
                                </div>
                                <div class="rating-block">
                                    <div class="ratig-inner">
                                        <h5 class="ratings">4.3</h5>
                                        <span class="rating-icon">
                                            <img src="./assets/images/ic-primary-rating.svg" alt="Rating">
                                        </span>
                                    </div>
                                    <p class="rated-time">2 days ago</p>
                                </div>
                            </div>
                            <div class="review-card-body">
                                <h4 class="review-text-data">
                                    Super! We booked the sunset ride with cowboy bbq. What a blast! Beautiful scenery,
                                    well
                                    kept horses and yummy bbq.
                                    Perfect! I can't wait to try the winery tour next time!
                                </h4>
                                <ul class="info-showcase">
                                    <li>
                                        <img src="./assets/images/ic-photo.svg" alt="Star">
                                        3 photos
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-lg-4">
            <div class="pre-and-his-wrap">

                <div class="restro-preferences-wrap">
                    <h4 class="grid-title">
                        Preferences
                    </h4>
                    <ul class="preferences-options">
                        <li>
                            <div class="form-group">
                                <input type="checkbox" id="italian">
                                <label for="italian">Italian</label>
                            </div>
                        </li>
                        <li>
                            <div class="form-group">
                                <input type="checkbox" id="mediterranean">
                                <label for="mediterranean">Mediterranean</label>
                            </div>
                        </li>
                        <li>
                            <div class="form-group">
                                <input type="checkbox" id="asian">
                                <label for="asian">Asian</label>
                            </div>
                        </li>
                        <li>
                            <div class="form-group">
                                <input type="checkbox" id="bars">
                                <label for="bars">Bars</label>
                            </div>
                        </li>
                    </ul>

                    <ul class="preferences-list">
                        <li>
                            <img src="./assets/images/review-avatar-1.png" alt="Image">
                            <div>
                                <h4 class="place-name">Diamond Slice Pizza</h4>
                                <p class="place-type">Restaurant</p>
                            </div>
                        </li>
                        <li>
                            <img src="./assets/images/review-avatar-2.png" alt="Image">
                            <div>
                                <h4 class="place-name">Homeroom</h4>
                                <p class="place-type">Restaurant</p>
                            </div>
                        </li>
                        <li>
                            <img src="./assets/images/review-avatar-3.png" alt="Image">
                            <div>
                                <h4 class="place-name">Vietnam Cafe</h4>
                                <p class="place-type">Cafe</p>
                            </div>
                        </li>
                        <li>
                            <img src="./assets/images/review-avatar-4.png" alt="Image">
                            <div>
                                <h4 class="place-name">Shandong Restaurant</h4>
                                <p class="place-type">Restaurant</p>
                            </div>
                        </li>
                        <li>
                            <img src="./assets/images/review-avatar-2.png" alt="Image">
                            <div>
                                <h4 class="place-name">Champa Garden</h4>
                                <p class="place-type">Restaurant</p>
                            </div>
                        </li>
                        <li>
                            <img src="./assets/images/review-avatar-1.png" alt="Image">
                            <div>
                                <h4 class="place-name">Vietnam Cafe</h4>
                                <p class="place-type">Cafe</p>
                            </div>
                        </li>
                        <li>
                            <img src="./assets/images/review-avatar-2.png" alt="Image">
                            <div>
                                <h4 class="place-name">Shandong Restaurant</h4>
                                <p class="place-type">Restaurant</p>
                            </div>
                        </li>
                        <li>
                            <img src="./assets/images/review-avatar-2.png" alt="Image">
                            <div>
                                <h4 class="place-name">Champa Garden</h4>
                                <p class="place-type">Restaurant</p>
                            </div>
                        </li>
                    </ul>
                </div>

                <hr class="devider">

                <div class="food-history-wrap">
                    <div class="history-head">
                        <h4 class="grid-title">History</h4>

                        <button class="btn btn-blue">
                            <img src="./assets/images/ic-membership.svg" alt="Icon">
                            Membership
                        </button>
                    </div>

                    <ul class="food-history-list">
                        <li>
                            <h5 class="order-day">Today</h5>
                            <h4 class="order-item">Diamond Slice Pizza</h4>
                        </li>
                        <li>
                            <h5 class="order-day">March 15</h5>
                            <h4 class="order-item">Homeroom</h4>
                            <h4 class="order-item">Vietnam Cafe</h4>
                        </li>
                        <li>
                            <h5 class="order-day">March 7</h5>
                            <h4 class="order-item">Shandong Restaurant</h4>
                            <h4 class="order-item">Champa Garden</h4>
                            <h4 class="order-item">Vietnam Cafe</h4>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>